import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unread',
  standalone: true,
})
export class UnreadPipe implements PipeTransform {
  transform(value: number | null) {
    if (value === null || value <= 0) {
      return '0';
    } else if (value > 0 && value <= 99) {
      return String(value);
    }
    return '99+';
  }
}
